import baseInitialize from './base';

baseInitialize();
